import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Circle from "../../../../../src/entities/Circle";
import PointManager from "./PointManager/PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import SliderManager from "./SliderManager";
import { ARC_COLOR_ARR, CENTER_OF_CIRCLE, CIRCLE_RADIUS, INFO_SLIDER_COORD, INITIAL_RADIANS } from "../types/Config";
import isPortail from "../../../../../src/utils/isPortial";
import GuideText from "../../../../../src/entities/GuideText";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";


export default class ComponentManager {
    private Game = Game.getInstance();
    private circleRadius = CIRCLE_RADIUS;
    private cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);
    PointManager = new PointManager(this.cCoord);
    PointTagManager = new PointTagManager(this.cCoord);
    LineManager = new LineManager()
    circle = new Circle(this.cCoord, INITIAL_RADIANS, ARC_COLOR_ARR);
    guideText = new GuideText(undefined, true);
    InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
    SliderManager = new SliderManager();
    CircleAnimationManager: CircleAnimationManager;

    constructor() {
        this.CircleAnimationManager = new CircleAnimationManager(
            this.PointManager,
            this.LineManager,
            this.circle,
            this.cCoord
        )

        this.drawElements();
        rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const chordsCoords = this.PointManager.getChordsCoords();
        const intersecCoord = this.PointManager.getIntersecCoord()

        this.circle.draw({ radians, radius: this.circleRadius });
        this.LineManager.draw(intersecCoord, chordsCoords);
    }
}